import { Typography } from "@mui/material";

export const TextBody = ({ ...props }) => (
  <Typography variant="body2" py={0.5} px={1.5} {...props} />
);
